import Citation from './Citation'
import type { IndustryStat } from '../data/types'

// Stat band type, per .claude/rules/unimo-design-system.md — exact px values,
// not mapped onto the (draft) type scale. Three figure treatments:
//   Type A — figure + short symbol, same line (unit prop). 116/60, symbol 88/50.
//   Type B — figure alone, then a word unit on its own line below (unitPhrase
//            prop), above the body copy. Unit-phrase line is 26/16, Orange, ExtraBold.
//   Type C — same rendering as Type A (a content decision, not a layout one).
// Figure/unit weight is ExtraBold 800 — a deliberate, stat-figures-only
// exception to the Light/Medium rule. Body copy is centred: the one approved
// exception to the centred-text anti-pattern, documented in the same rules file.
//
// The figure block (everything above the body copy) has a fixed height so a
// Type B card's extra line doesn't push its body copy lower than its Type A/C
// neighbours in the same row — all three cards' body copy starts level.
export function StatCard({ figure, unit, unitPhrase, body, citation }: IndustryStat) {
    return (
        <div className="min-w-0 text-center">
            <div className="flex h-[80px] flex-col items-center justify-center lg:h-[150px]">
                <div className="break-words font-extrabold leading-none text-unimo-site-orange">
                    <span className="text-[60px] leading-none lg:text-[116px]">{figure}</span>
                    {unit && <span className="text-[50px] leading-none lg:text-[88px]">{unit}</span>}
                    <Citation n={citation} />
                </div>
                {unitPhrase && (
                    <div className="mt-1 break-words text-[16px] font-extrabold leading-none text-unimo-site-orange lg:text-[26px]">
                        {unitPhrase}
                    </div>
                )}
            </div>
            <p className="mt-3 text-[16px] font-light leading-snug text-unimo-slate lg:text-[26px]">{body}</p>
        </div>
    )
}

export default StatCard
